module.exports = __webpack_public_path__ + "0941abb0133efbce6f427cd75d40b5f2.png";